import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Copy, Printer } from '@phosphor-icons/react';
import { Button } from '../ui/button';
import { Switch } from '../ui/switch';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const groupByProduct = (rows) =>
  rows.reduce((acc, r) => {
    (acc[r.product_name] = acc[r.product_name] || []).push(r);
    return acc;
  }, {});

export const ProductionList = () => {
  const [scope, setScope] = useState('open');
  const [paidOnly, setPaidOnly] = useState(false);
  const [data, setData] = useState({ rows: [], orders_count: 0, total_pieces: 0 });

  const load = useCallback(() => {
    axios.get(`${API}/store/production-list`, { params: { scope, paid_only: paidOnly }, withCredentials: true })
      .then((r) => setData(r.data))
      .catch(() => toast.error('Erro ao carregar lista de produção'));
  }, [scope, paidOnly]);

  useEffect(() => { load(); }, [load]);

  const groups = groupByProduct(data.rows);

  const copyText = () => {
    const text = Object.entries(groups).map(([name, rows]) =>
      `*${name}* (${rows.reduce((s, r) => s + r.quantity, 0)})\n` + rows.map((r) => `- Tam ${r.size} / ${r.color}: ${r.quantity}`).join('\n')
    ).join('\n\n');
    navigator.clipboard?.writeText(`Lista de produção - Tia Karol Sports\n\n${text}`)?.catch(() => {});
    toast.success('Lista copiada! Cole no WhatsApp do fornecedor.');
  };

  return (
    <div className="space-y-5" data-testid="production-list">
      <div className="flex flex-wrap items-center gap-3 justify-between">
        <div className="flex flex-wrap items-center gap-2">
          <div className="inline-flex bg-[#F5F2EB] rounded-md p-1">
            {[['open', 'Em aberto'], ['all', 'Inclui entregues']].map(([k, l]) => (
              <button key={k} onClick={() => setScope(k)} className={`px-3 py-1.5 text-xs font-medium rounded transition-colors ${scope === k ? 'bg-white shadow-sm text-[#1A1A1A]' : 'text-[#73706A]'}`} data-testid={`production-scope-${k}`}>{l}</button>
            ))}
          </div>
          <label className="flex items-center gap-2 text-xs text-[#1A1A1A]">
            <Switch checked={paidOnly} onCheckedChange={setPaidOnly} data-testid="production-paid-only" /> Só pedidos pagos (sinal ou total)
          </label>
        </div>
        <div className="flex gap-2">
          <Button variant="outline" size="sm" onClick={copyText} disabled={!data.rows.length} data-testid="production-copy-btn"><Copy size={14} className="mr-1.5" /> Copiar p/ WhatsApp</Button>
          <Button variant="outline" size="sm" onClick={() => window.print()} data-testid="production-print-btn"><Printer size={14} className="mr-1.5" /> Imprimir</Button>
        </div>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
        <div className="bg-white border border-[#E6E2D8] rounded-lg p-4"><p className="text-xs text-[#73706A]">Pedidos</p><p className="text-2xl font-bold font-['Outfit']" data-testid="production-orders-count">{data.orders_count}</p></div>
        <div className="bg-white border border-[#E6E2D8] rounded-lg p-4"><p className="text-xs text-[#73706A]">Total de peças</p><p className="text-2xl font-bold font-['Outfit'] text-[#E85D04]" data-testid="production-total-pieces">{data.total_pieces}</p></div>
      </div>

      {data.rows.length === 0 ? (
        <p className="bg-white border border-[#E6E2D8] rounded-lg p-8 text-center text-[#73706A]">Nenhuma peça para produzir com esse filtro</p>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {Object.entries(groups).map(([name, rows], gi) => (
            <div key={name} className="bg-white border border-[#E6E2D8] rounded-lg overflow-hidden" data-testid={`production-product-${gi}`}>
              <div className="px-4 py-3 bg-[#F5F2EB] flex justify-between items-center">
                <p className="font-semibold text-[#1A1A1A]">{name}</p>
                <span className="text-sm font-bold text-[#E85D04]">{rows.reduce((s, r) => s + r.quantity, 0)} peças</span>
              </div>
              <table className="w-full text-sm">
                <thead><tr className="text-left text-[11px] uppercase text-[#73706A]"><th className="px-4 py-2">Tamanho</th><th className="px-4 py-2">Cor</th><th className="px-4 py-2 text-right">Qtd</th></tr></thead>
                <tbody>
                  {rows.map((r, ri) => (
                    <tr key={ri} className="border-t border-[#F0ECE3]" data-testid={`production-row-${gi}-${ri}`}>
                      <td className="px-4 py-2 font-medium">{r.size}</td>
                      <td className="px-4 py-2">{r.color}</td>
                      <td className="px-4 py-2 text-right font-bold">{r.quantity}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
